import { useState } from 'react';
import PromoCode from 'components/promo_code';

const PromoCodeWithLink = () => {
  const [showPromoCode, setShowPromoCode] = useState(false);

  return (
    <div>
      {!showPromoCode && (
        <button
          type="button"
          className="link-primary text-decoration-underline"
          onClick={() => setShowPromoCode(true)}
        >
          I have a promo code
        </button>
      )}

      {showPromoCode && (
        <div>
          <h5 className="my-3">Apply a promo code</h5>
          <PromoCode />
        </div>
      )}
    </div>
  );
};

export default PromoCodeWithLink;
